export const SET_CREDITS_PAYMENTS = 'rpb2b-react/CREDITSs/SET_CREDITS_PAYMENTS';
export type SET_CREDITS_PAYMENTS = typeof SET_CREDITS_PAYMENTS;

export const SET_CREDITS_STATUS_FILTER =
  'rpb2b-react/CREDITSs/SET_CREDITS_STATUS_FILTER';
export type SET_CREDITS_STATUS_FILTER = typeof SET_CREDITS_STATUS_FILTER;

export const SET_CREDITS_PAGE_NUMBER =
  'rpb2b-react/CREDITSs/SET_CREDITS_PAGE_NUMBER';
export type SET_CREDITS_PAGE_NUMBER = typeof SET_CREDITS_PAGE_NUMBER;

export const SET_CREDITS_PAGE_SIZE =
  'rpb2b-react/CREDITSs/SET_CREDITS_PAGE_SIZE';
export type SET_CREDITS_PAGE_SIZE = typeof SET_CREDITS_PAGE_SIZE;

export const SET_CREDITS_TOTAL_ELEMENTS =
  'rpb2b-react/CREDITSs/SET_CREDITS_TOTAL_ELEMENTS';
export type SET_CREDITS_TOTAL_ELEMENTS = typeof SET_CREDITS_TOTAL_ELEMENTS;

export const SET_CREDITS_TOTAL_PAGES =
  'rpb2b-react/CREDITSs/SET_CREDITS_TOTAL_PAGES';
export type SET_CREDITS_TOTAL_PAGES = typeof SET_CREDITS_TOTAL_PAGES;

export const SET_CREDITS_IS_PENDING =
  'rpb2b-react/CREDITSs/SET_CREDITS_IS_PENDING';
export type SET_CREDITS_IS_PENDING = typeof SET_CREDITS_IS_PENDING;

export const SET_CREDITS_ERROR = 'rpb2b-react/CREDITSs/SET_CREDITS_ERROR';
export type SET_CREDITS_ERROR = typeof SET_CREDITS_ERROR;

export default {
  SET_CREDITS_PAYMENTS,
  SET_CREDITS_STATUS_FILTER,
  SET_CREDITS_PAGE_NUMBER,
  SET_CREDITS_PAGE_SIZE,
  SET_CREDITS_TOTAL_ELEMENTS,
  SET_CREDITS_TOTAL_PAGES,
  SET_CREDITS_IS_PENDING,
  SET_CREDITS_ERROR
};
